// extracted by mini-css-extract-plugin
export default {"link":"PageLink_link__vXNFF"};